import React, { useEffect, useRef } from 'react';
import { Container, Row } from 'reactstrap';

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import LoadingPage from '../../pages/loading';

const PlanContainerComponent = ({ 
 }) => {
  const imgWidth = 1000;
  const imgHeight = 800;

  return <Container>
    <Row className="mapContainer">
  <TransformWrapper
    initialScale={1}
    initialPositionX={200}
    initialPositionY={100}
  >
    {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
      <React.Fragment>
        <div className="tools">
          <button onClick={() => zoomIn()}>+</button>
          <button onClick={() => zoomOut()}>-</button>
          <button onClick={() => resetTransform()}>x</button>
        </div>
        <TransformComponent wrapperStyle={{ maxWidth: "100%", maxHeight: "calc(100vh - 50px)" }}>
          <img src="images/plans/benslimane/lots.jpg" alt="test" />
          <div>Example text</div>
        </TransformComponent>
      </React.Fragment>
    )}
  </TransformWrapper>
  </Row>
  </Container>

//   return <TransformWrapper
//   defaultScale={1}
//   defaultPositionX={200}
//   defaultPositionY={100}>
//   {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
//     <React.Fragment>
//       <div className="tools">
//         <button onClick={zoomIn}>+</button>
//         <button onClick={zoomOut}>-</button>
//         <button onClick={resetTransform}>x</button>
//       </div>
//       <TransformComponent>
//         <img src="2.jpg" alt="test" />
//         <div>Example text</div>
//       </TransformComponent>
//     </React.Fragment>
//   )}
// </TransformWrapper>
};

export default PlanContainerComponent;
